<template>
    <div class="wrapper -ficha-receta" v-if="recipe">
        <div class="container top-noticia row-between">
            <div class="breadcrumb">
                <nav class="container row-start">
                    <router-link :to="{ name: 'home' }">Hiper Usera</router-link>
                    <router-link :to="{ name: 'recetas' }">Recetas</router-link>
                </nav>
            </div>
            <router-link class="back" :to="{ name: 'recetas' }">Volver</router-link>
        </div>


        <div class="contenedor-titulo-recetas row-center">
            <div class="container">
                <h1>{{ recipe.name }}</h1>
            </div>
        </div>

        <div class="intro-receta row-center">
            <div class="imagen-principal">
                <img :src="recipe.header_img.url" :alt="recipe.title">
            </div>
            <div class="contenedor-ingredientes">
                <div class="stats row-start">
                    <h3 title="Dificultad" class="dificultad">{{ levels[recipe.dificulty] }}</h3>
                    <h3 title="Tiempo" class="tiempo">{{ recipe.time }} min</h3>
                    <h3 title="Comensales" class="comensales">{{ recipe.portions }}</h3>
                </div>
                <h2>Ingredientes</h2>
                <ul class="ingredientes">
                    <li :key="key" v-for="(ingrediente, key) in recipe.ingredients">{{ ingrediente }}</li>
                </ul>
            </div>
        </div>

        <div class="contenedor-titulo container">
            <h2 class="title -point -rojo">¡A cocinar!</h2>
        </div>

        <div class="cuerpo-receta container">
            <div class="contenedor-texto-editor">
                <editor :object="recipe.description"></editor>
            </div>
            <nav class="share row-start">
                <span>Compartir</span>
                <a target="_blank" :href="`http://www.facebook.com/sharer.php?u=${full_route}&t=${recipe.name}`">
                    <img src="@/assets/img/facebook-green.svg" alt="Facebook">
                </a>

                <a target="_blank" :href="`http://twitter.com/intent/tweet?url=${full_route}&text=${recipe.name}`">
                    <img src="@/assets/img/twitter-green.svg" alt="Twitter" style="min-width: 25px;" />
                </a>
                <a target="_blank" :href="`https://www.linkedin.com/shareArticle?mini=false&url=${full_route}&title=${recipe.name}`">
                    <img src="@/assets/img/linkedin-green.svg" alt="Linkedin">
                </a>
            </nav>
        </div>
        <img src="@/assets/img/espumadera.png" class="espumadera" alt="espumadera">
        <img src="@/assets/img/brocha.png" class="brocha" alt="espumadera">
    </div>
</template>
<script>
import { recipesStore } from '@/store/recipes'
import editor from '@/components/editor-js';
export default {
    name: 'ficha-receta',
    props: ['slug'],
    components: {
        editor
    },
    data() {
        const store = recipesStore();
        return {
            store: store,
            recipe: null,
            levels: [
                'Fácil',
                'Medio',
                'Dificil'
            ]
        }
    },
    computed: {
        full_route() {
            return window.location.href;
        }
    },
    mounted() {
        let t = this;
        this.recipe = this.store.getRecipe(this.slug);
        if (this.recipe == null) {
            this.store.getRecipeCall({ slug: this.slug }).then(function (result) {
                t.recipe = result.data;
                t.changeMetaUrl()
            });
        } else {
            t.changeMetaUrl()
        }
    },
    methods: {
        changeMetaUrl: function () {
            let title = this.recipe.name
            let description = this.recipe.header

            document.title = title
            document.head.querySelector("[name=description]").content = description
            document.head.querySelector("[name=title]").content = title
            //
            document.head.querySelector("[property='og:title']").content = title;
            document.head.querySelector("[property='og:image']").content = this.recipe.header_img.url;
            document.head.querySelector("[property='og:description']").content = description
            //
            document.head.querySelector("[name='twitter:title']").content = title;
            document.head.querySelector("[name='twitter:description']").content = description;
            document.head.querySelector("[name='twitter:image']").content = this.recipe.header_img.url;
            document.head.querySelector("[name='twitter:text:title").content = title;
        },
    }
}
</script>